import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(MessageService);
  return next(req).pipe(
    catchError(err => {
      if (err.status === 400) {
          const message = err.error.message.replaceAll(/<.?\/?.>/g, '\"');
          console.warn(message);
          toast.add({severity: 'warn', summary: 'Duplicate - Not saved', detail: message, key: 'center', life: 10000});
      } else {
        toast.add({
          severity: 'error',
          summary: `${err.status === 0 ? 'Network:' : err.status} ${err.statusText}`,
          detail: `${err.url} \r\n ${err.error.message}`,
          key: 'main',
          life: 5000
        });
      }
      // return the error so a client level handler can catch it
      return throwError(() => err);
    })
  )
};
